import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthFlowFrame from "../../components/AuthFlowFrame";
import { AuthFlowButton } from "../../types";
import { showError } from "../../helpers";
import { facebookRedirectUrl } from "../../services";
import { Content } from "@jobber/components/Content";
import { Link } from "@jobber/components/Link";
import { Text } from "@jobber/components/Text";

function Step1() {
    const [buttonLink, setButtonLink] = useState("");
    const location = useLocation();

    useEffect(() => {
        if (location.state?.error) {
            const onRetry = async () => {
                const state = sessionStorage.getItem('state');
                if (!state) return;
                const { redirect_url } = await facebookRedirectUrl(state);
                window.location.assign(redirect_url);
            };
            showError(location.state.error, onRetry);
        }
    }, []);

    useEffect(() => {
        (async () => {
            try {
                const state = sessionStorage.getItem('state');
                if (!state) {
                    throw new Error("Missing session state — please restart the setup flow.");
                }
                const { redirect_url } = await facebookRedirectUrl(state);
                setButtonLink(redirect_url);
            } catch(e: any) {
                showError("Error establishing connection with Facebook: " + e.message);
            }
        })();
    }, []);


    const button: AuthFlowButton = {
        link: buttonLink,
        text: "Connect to Facebook",
        type: "primary",
        disabled: false,
        loading: false,
    }

    return (
        <AuthFlowFrame
            pretitle={"Let's get you set up"}
            title={"Connect to Facebook"}
            step={1}
            totalSteps={3}
            button={button}
        >
            <Content spacing={"base"}>
                <Text size={"large"}>
                    After connecting your Facebook account, your integration will be ready to go!
                </Text>
                <Text size={"base"} variation={"subdued"}>
                    If you don't have a Facebook account, <Link url={"https://www.facebook.com"} external={true}>create a Facebook account</Link> and then come back to this tab to finish setting up your integration.
                </Text>
            </Content>
        </AuthFlowFrame>
    );
}

export default Step1;
